// src/lib/agent/agentControl.ts
//
// Tiny pub/sub used by the Header's "Ask AV-Concierge" trigger to
// tell the floating AgentBalloon to open. The Header does not have a
// direct reference to the Balloon (it lives inside Layout), so we
// dispatch a window CustomEvent when the user clicks the header
// button.
//
// Pattern mirrors agentBus but lives at module scope on window so
// subscribers from any descendant component can join.

const OPEN_EVENT = "bench:agent:open";

declare global {
  interface WindowEventMap {
    [OPEN_EVENT]: CustomEvent<undefined>;
  }
}

/** Fire-and-forget ask for the balloon to open. */
export function openAgent(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

/** Subscribe to "open me" requests. Returns a teardown fn. */
export function onOpenAgent(fn: () => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const handler = () => fn();
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}
